import React from "react";
import PropTypes from "prop-types";
import InlineShare from "./InlineShare";
import Modal from "react-modal";
import ShareMob from "./ShareMob";

class Document extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShareOpen: false,
            modalIsOpen: false,
            width: window.innerWidth,
            isMobile: false
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.triggerShare = this.triggerShare.bind(this);
    }

    componentWillMount() {
        window.addEventListener("resize", this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({
            width: window.innerWidth,
            isMobile: this.state.width <= 767
        });
    };

    triggerShare() {
        this.setState({
            isShareOpen: !this.state.isShareOpen
        });
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    render() {
        const {
            description,
            thumbnail,
            src,
            recent,
            title,
            type
        } = this.props.resource;

        const { width, isShareOpen, modalIsOpen } = this.state || {};
        const isMobile = width <= 767;

        if (isMobile) {
            return (
                <article className="document">
                    <figure
                        className={`document__fig ${recent ? "is-new" : ""} ${
                            type === "link" ? "is-link" : ""
                        }`}
                        style={{ backgroundImage: `url(${thumbnail})` }}
                    />
                    <aside className="document__description">
                        <h3 className="resources__title">{title}</h3>
                        <p className="resources__copy">{description}</p>
                        <a
                            target="_blank"
                            href={src}
                            className="resources__btn"
                            data-download-title={title}
                        >
                            View
                        </a>
                        <button
                            className={`resources__btn resources__btn--share ${
                                isShareOpen ? "is-active" : ""
                            }`}
                            onClick={this.openModal}
                            data-cta={`Share Resource: ${title}`}
                        >
                            Share
                        </button>
                        <Modal
                            {...this.props}
                            className="user-guide"
                            isOpen={modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            overlayRef={node => (this.overlayRef = node)}
                            contentRef={node => (this.contentRef = node)}
                        >
                            <ShareMob
                                {...this.props}
                                closeModal={this.closeModal}
                            />
                        </Modal>
                    </aside>
                </article>
            );
        } else {
            return (
                <article className="document">
                    <figure
                        className={`document__fig ${recent ? "is-new" : ""} ${
                            type === "link" ? "is-link" : ""
                        }`}
                        style={{ backgroundImage: `url(${thumbnail})` }}
                    />
                    <aside className="document__description">
                        <h3 className="resources__title">{title}</h3>
                        <p className="resources__copy">{description}</p>
                        <section className="resources__btns">
                            <a
                                target="_blank"
                                href={src}
                                className="resources__btn"
                                data-download-title={title}
                            >
                                View
                            </a>
                            <button
                                className={`resources__btn resources__btn--share ${
                                    isShareOpen ? "is-active" : ""
                                }`}
                                onClick={this.triggerShare}
                                data-cta={`Share Resource: ${title}`}
                            >
                                Share
                            </button>
                            <InlineShare
                                {...this.props}
                                isShareOpen={isShareOpen}
                                triggerShare={this.triggerShare}
                            />
                        </section>
                    </aside>
                </article>
            );
        }
    }
}

export default Document;



// WEBPACK FOOTER //
// ./src/components/Document.js